import styled from 'styled-components';
import LogoImage from 'assets/detour_header_logo.svg';
import OhioDetourLogoImage from 'assets/icons/WHT.svg';
import { CalciteH1 } from 'calcite-react/Elements';
import {Link as LinkRouter} from 'react-router-dom';

const StyledLogo = styled(LinkRouter)`
  background-image: url(${() => LogoImage});
  margin-left: 28px;
  width: 48px;
  height: 50px;
`;

const StyledHeader = styled.header`
  display: flex;
  width: 100%;
  color: ${({ theme }) => theme.palette.header.main};
  z-index: 2;
  justify-content: space-between;
  align-items: center;
  line-height: normal;
  padding: 0.5rem 0;
  background: ${({ theme }) => theme.palette.header.main};
  font-family: Montserrat;
  font-weight: 400;
`;

const StyledCalciteH1 = styled(CalciteH1)`
  font-size: 1.4rem;
  line-height: inherit;
  text-align: center;
  marginLeft: 50px;
  font-weight: 500;
  a {
    color: #ffffff;
    text-decoration: none;
  }
`;

const SearchWrapper = styled.div`
  background: ${({ theme }) => theme.palette.header.main}};
  width: 16rem;
  margin-inline-start: 1rem;
  text-align: start;

  @media (max-width: 575px) {
    width: 100%;
  }

  input {
    border: 0;
    margin: 0;
  }
`;

const UserWrapper = styled.div`
  text-align: end;
  margin-inline-end: 1rem;
`;

const StyledMainLogo = styled.div`
  background-image: url(${() => OhioDetourLogoImage});
  background-repeat: no-repeat;
  background-size: contain;
  margin-top: 1rem;
  margin: 0 auto;
  width: 360px;
  height: 38px;
  cursor: pointer;
`;

export { StyledLogo, StyledMainLogo, StyledHeader, StyledCalciteH1, SearchWrapper, UserWrapper };
